// extracted by mini-css-extract-plugin
export default {"text_content":"styles_text_content__ZyLOL"};